var paragraph_default = {
  "fontElementMap": "VGQYa",
  "elementSpacing": "f1-1G",
  "text": "IFLJx f1-1G",
  "child": "GnvzP"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
